(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealSelector = '[data-reveal], [data-reveal-group]';
  const editorMode = window.Shopify?.designMode || document.documentElement.classList.contains('theme-editor');
  let revealObserver;

  const revealImmediately = (element) => {
    element.classList.remove('is-reveal-pending');
    element.classList.add('is-visible');
    revealObserver?.unobserve(element);
  };

  const prepareReveals = (scope = document) => {
    const elements = [...scope.querySelectorAll(revealSelector)];
    if (scope.matches?.(revealSelector)) elements.unshift(scope);

    elements.forEach((element) => {
      if (element.dataset.motionReady === 'true') return;
      element.dataset.motionReady = 'true';

      const bounds = element.getBoundingClientRect();
      if (editorMode || reducedMotion.matches || !revealObserver || bounds.top < window.innerHeight * 0.92 || element.querySelector(revealSelector)) {
        revealImmediately(element);
        return;
      }

      revealObserver.observe(element);
      element.classList.add('is-reveal-pending');
    });
  };

  const initializeMotion = (scope = document) => {
    if (!editorMode && !reducedMotion.matches && revealObserver) document.documentElement.classList.add('motion-ready');
    prepareReveals(scope);
  };

  if (!editorMode && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) revealImmediately(entry.target);
      });
    }, { rootMargin: '0px 0px -24px 0px', threshold: 0 });
  }

  const header = document.querySelector('[data-scroll-header]');
  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    ticking = false;
    if (!header || editorMode || reducedMotion.matches) return;
    const currentScrollY = Math.max(window.scrollY, 0);
    const movingDown = currentScrollY > lastScrollY;
    header.classList.toggle('is-scrolled', currentScrollY > 12);
    header.classList.toggle('is-hidden', movingDown && currentScrollY > 160);
    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  document.addEventListener('shopify:section:load', (event) => initializeMotion(event.target));
  document.addEventListener('wowthings:content:load', (event) => initializeMotion(event.target));
  document.addEventListener('focusin', (event) => {
    let element = event.target.closest(revealSelector);
    while (element) {
      revealImmediately(element);
      element = element.parentElement?.closest(revealSelector);
    }
  });
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    document.documentElement.classList.remove('motion-ready');
    document.querySelectorAll(revealSelector).forEach(revealImmediately);
    header?.classList.remove('is-hidden');
  });
  initializeMotion();
})();
